import { render } from "./MeetExpert.vue?vue&type=template&id=05a21bbc&scoped=true"
import script from "./MeetExpert.vue?vue&type=script&lang=js"
export * from "./MeetExpert.vue?vue&type=script&lang=js"

import "./MeetExpert.vue?vue&type=style&index=0&id=05a21bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a21bbc"]])

export default __exports__